<template lang="pug">
	.select(:class="{'select_category': selectedVal.color}")
		.select__label(v-text="name")
		v-select(:style="selectedVal.color ? ('background-color: ' + selectedVal.color) : ''" :label="label" :options="options" :searchable="false" v-model="selectedVal" @input="$emit('input', selectedVal)")
</template>

<script>

	import 'vue-select/dist/vue-select.css';

	export default {
		name: 'Card',
		props: {
			label: String,
			options: Array,
			name: String,
			selected: Object
		},
		data: function(){
			return {
				selectedVal: ''
			}
		},
		created() {
			this.selectedVal = this.selected;
		},
		watch: {
			options() {
				this.selectedVal = this.selected;
			},
			selected() {
				this.selectedVal = this.selected;
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

  >>> .v-select {
		width: 100%;
		height: 50px;
		background-color: #fff;
		box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.1);
		position: relative;
		margin-top: 13px;
		cursor: pointer;

		.vs__search {
			position: absolute;
			width: 100%;
			height: 100%;
			z-index: 1;
			background-color: transparent;
			font: 700 21px/52px 'Helvetica', Arial, sans-serif;
			padding: 0 20px;
			text-align: center;
			left: 0;
			top: 0;
			cursor: pointer;
		}

		.vs__selected {
			font: 700 21px/52px 'Helvetica', Arial, sans-serif;
			text-align: center;
			white-space: nowrap;
			text-overflow: ellipsis;
			max-width: 100%;
			padding: 0 20px 0 20px;
			width: 100%;
			display: block;
		}

		.vs__actions {
			display: none;
		}

		.vs__dropdown-toggle {
			height: 100%;
			border: none;
			padding: 0;

			.vs__selected {
				height: 100%;
				margin: 0;
				padding: 0;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.vs__dropdown-menu {
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			background-color: #fff;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.1);
			text-align: left;
			border-top: 1px solid #F2F2F2;
			z-index: 1;

			li {
				height: 50px;
				padding: 0 20px;
				font: 700 21px/52px 'Helvetica', Arial, sans-serif;
				cursor: pointer;
				transition: background-color .3s ease, color .3s ease;
				border-bottom: 1px solid #F2F2F2;
				// padding-right: 70px;
				text-align: center;

				&:last-child {
					border-bottom: none;
				}

				@media screen and (min-width: 1201px) {
					&:hover {
						background-color: #EF3E33;
						color: #fff;
					}
				}
			}
		}

		&:after {
			content: "";
			display: block;
			width: 50px;
			height: 100%;
			position: absolute;
			right: 0;
			top: 0;
			background: url('../assets/img/select.svg') no-repeat center center;
			transition: transform .2s ease;
			z-index: 0;

			@media screen and (min-width: 1201px) {
				&:hover {
					opacity: .7;
					transition: opacity .3s ease;
				}
			}
		}

		&:before {
			content: "";
			display: block;
			width: 50px;
			height: 100%;
			position: absolute;
			right: 0;
			top: 0;
			z-index: 0;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.1);
		}

		svg {
			display: none;
		}

		&.vs--open {
			&:after {
				transform: rotate(180deg);
			}
		}


	}

	.select {
		display: inline-block;
		vertical-align: top;
		margin-right: 20px;
		width: 413px;

		&:last-child {
			margin-right: 0;
		}

		&__label {
			text-align: left;
		}

		&_category {
      >>> .v-select {

				.vs__selected {
					color: #fff;
				}

				&:after {
					background: url('../assets/img/dropdown_white.svg') no-repeat center center;
					transform: rotate(180deg);
				}

				&.vs--open {
					&:after {
						transform: rotate(0);
					}
				}
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.select {
			width: 100%;
			margin: 0;
			margin-bottom: 30px;

			&:last-child {
				margin-bottom: 0;
			}

			&__label {
				display: none;
			}
		}

    >>> .v-select {
			margin-top: 0;
		}
	}

</style>
